<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Nuevo Cobro
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>

                  <form @submit.prevent="saveElement">
                    <div class="row mb-3">
                      <div class="col-12 col-md-6">
                        <div class="col-12 p-0 mb-2">
                          <label for="">Título del cobro</label>
                          <input
                            type="text"
                            placeholder="Título"
                            class="form-control form-control-sm"
                            v-model="form.title"
                            required
                          />
                        </div>

                        <div class="col-12 p-0">
                          <label for="">Monto por pagar</label>
                          <input
                            ref="priceInput"
                            type="text"
                            placeholder="Monto"
                            class="form-control form-control-sm"
                            v-model="form.expected_amount"
                            v-format-price
                            required
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-6 pr-md-4">
                        <div class="col-12 p-0 mb-2">
                          <label for="">Modo de Cobro</label>
                          <Multiselect
                            v-model="form.id_type_payment_mode"
                            :options="type_payment_modeList"
                            label="name"
                            @select="restrictInput($event)"
                            placeholder="Seleccione el modo"
                            required
                          />
                        </div>
                        <div
                          class="col-12 p-0 mb-2"
                          v-if="
                            form.id_type_payment_mode !== null &&
                            form.id_type_payment_mode.id !== '' &&
                            form.id_type_payment_mode.id === 1
                          "
                        >
                          <label for="">Tipo de empresa</label>
                          <Multiselect
                            v-model="form.id_type_company"
                            :options="type_companyList"
                            label="name"
                            placeholder="Selecciona un tipo"
                            required
                          />
                        </div>
                        <div
                          class="col-12 p-0 mb-2"
                          v-if="
                            form.id_type_payment_mode !== null &&
                            form.id_type_payment_mode.id !== '' &&
                            form.id_type_payment_mode.id === 2
                          "
                        >
                          <label for="">Empresa</label>
                          <Multiselect
                            v-model="form.id_company"
                            :options="companys"
                            label="company_name"
                            placeholder="Selecciona una empresa"
                            required
                          />
                        </div>
                        <div class="col-12 p-0 mb-2">
                          <label for="">Tipo de cobro</label>
                          <Multiselect
                            v-model="form.id_type_payment"
                            :options="type_paymentList"
                            label="name"
                            placeholder="Seleccione un tipo de cobro"
                            required
                          />
                        </div>
                        <div
                          class="col-12 p-0 mb-2"
                          v-if="
                            form.id_type_payment_mode !== null &&
                            form.id_type_payment_mode.id !== '' &&
                            form.id_type_payment_mode.id === 1
                          "
                        >
                          <label for="">Tipo de servicio</label>
                          <Multiselect
                            v-model="form.id_type_service"
                            :options="type_serviceList"
                            label="name"
                            placeholder="Seleccione una opción"
                            required
                          />
                        </div>
                        <div class="col-12 p-0 mb-2">
                          <label for="">Moneda</label>
                          <Multiselect
                            v-model="form.id_type_currency"
                            :options="type_currencyList"
                            label="name"
                            placeholder="Seleccione una moneda"
                            required
                          />
                        </div>
                        <div class="col-12 p-0 mb-2">
                          <div
                            class="w-100 d-flex justify-content-between mt-3"
                          >
                            <label for="isPublic">incluye IVA</label>
                            <input
                              type="checkbox"
                              id="isPublic"
                              v-model="form.has_iva"
                              @change="form.has_iva = form.has_iva ? 1 : 0"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100">
                        <button
                          type="submit"
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          :disabled="isSubmitting"
                        >
                          Crear Cobro
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      form: {
        title: '',
        expected_amount: '',

        id_type_payment_mode: '',
        id_type_company: '',
        id_company: '',
        id_type_payment: '',
        id_type_service: '',
        id_type_currency: '',
        has_iva: 0
      },
      companys: [],

      type_payment_modeList: [],
      type_companyList: [],
      type_paymentList: [],
      type_serviceList: [],
      type_currencyList: [],

      dataTypes: [
        { name: 'type_payment_mode' },
        { name: 'type_company' },
        { name: 'type_payment' },
        { name: 'type_service' },
        { name: 'type_currency' }
      ],
      isSubmitting: false
    }
  },
  methods: {
    ...mapActions(['getData', 'createData']),
    returnUrl() {
      this.$router.go(-1)
    },
    loadDataTypes() {
      try {
        for (const element of this.dataTypes) {
          const form = {
            url: element.name + '/all',
            params: {
              active: 1
            }
          }
          this.getData(form)
            .then((response) => {
              if (response.code === 200) {
                this[element.name + 'List'] = response.data.map((item) => ({
                  id: item.id,
                  name: item.name
                }))
                if (element.name === 'type_service') {
                  this.type_serviceList.unshift({
                    id: 0,
                    name: 'Sin Delivery'
                  })
                }
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      } catch (error) {
        console.error(error)
      }
    },
    loadCompanys() {
      const form = {
        url: 'user/all',
        params: {
          active: 1,
          id_type_user_status: 2
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.companys = response.data
              .filter(
                (user) =>
                  user.company && user.id_company !== 0 && user.company !== null
              )
              .map((user) => ({
                id: user.id,
                id_company: user.company.id,
                company_name: user.company.company_name
              }))
              .sort((a, b) => a.company_name.localeCompare(b.company_name))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    isFormValid(form) {
      return (
        form.title != null &&
        form.title !== '' &&
        form.id_type_payment != null &&
        form.id_type_payment !== '' &&
        form.id_type_currency != null &&
        form.id_type_currency !== '' &&
        form.expected_amount != null &&
        form.expected_amount !== '' &&
        form.expected_amount !== 0
      )
    },
    saveElement() {
      if (!this.isFormValid(this.form)) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (
        this.form.id_type_payment_mode.id === 1 &&
        (this.form.id_type_service === '' || this.form.id_type_service === null)
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, seleccione un tipo de servicio.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      this.isSubmitting = true

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar este pago?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      }).then((result) => {
        if (result.value) {
          const form = {
            url: 'payment_fee/save_custom',
            data: {
              title: this.form.title,
              expected_amount: this.form.expected_amount,
              id_type_payment_mode: this.form.id_type_payment_mode.id,
              id_type_company:
                this.form.id_type_company.id || this.form.id_type_company,
              id_company:
                this.form.id_company.id_company || this.form.id_company,
              id_type_payment: this.form.id_type_payment.id,
              id_type_service: this.form.id_type_service.id,
              id_type_currency: this.form.id_type_currency.id,
              has_iva: this.form.has_iva
            }
          }
          if (this.form.id_type_payment_mode.id === 2) {
            delete form.id_type_service
          }
          this.createData(form)
            .then(async (response) => {
              if (response.code === 200) {
                await Swal.fire(
                  '¡Éxito!',
                  'La tarifa de pago ha sido creada correctamente.',
                  'success'
                )
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire('Error', 'Ocurrió un error al crear el pago.', 'error')
            })
            .finally(() => {
              this.isSubmitting = false
            })
        }
      })
    },
    restrictInput(event) {
      if (event.id === 1) {
        this.form.id_company = 0
      } else {
        this.form.id_type_company = 0
      }
    }
  },
  mounted() {
    this.loadCompanys()
    this.loadDataTypes()
  }
}
</script>

<style>
.btn-back {
  background-color: #1a438b;
  color: white;
  border: none;
  font-size: 14px;
  border-radius: 25px;
  padding: 4px 12px;
}

.btn-back:hover {
  background-color: #0d2a57;
}
</style>
